export default theme => ({
  validationErrorContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  inputModeTitle: {
    marginTop: "16px",
    marginBottom: "16px",
  },
  inputModeDescription: {
    marginBottom: "16px",
  },
  inputModeButtons: {
    display: "flex",
    gap: "16px",
    marginBottom: "16px",
  },
  hiddenFileInput: {
    display: "none",
  },
  fileUploadedText: {
    marginTop: "8px",
    display: "flex",
    alignItems: "center",
  },
  fileUploadedName: {
    marginLeft: "4px",
  },
  uploadError: {
    marginTop: "8px",
  },
  validationErrorsContainer: {
    marginTop: "16px",
  },
});
